"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Parser = void 0;
var Scanner_1 = require("./Scanner");
var RowParser_1 = require("./RowParser");
var Token_1 = require("./Token");
var Parser = /*#__PURE__*/function () {
  function Parser(parserOptions) {
    _classCallCheck(this, Parser);
    _defineProperty(this, "parserOptions", void 0);
    _defineProperty(this, "rowParser", void 0);
    this.parserOptions = parserOptions;
    this.rowParser = new RowParser_1.RowParser(this.parserOptions);
  }
  return _createClass(Parser, [{
    key: "parse",
    value: function parse(line, hasMoreData) {
      var scanner = new Scanner_1.Scanner({
        line: Parser.removeBOM(line),
        parserOptions: this.parserOptions,
        hasMoreData: hasMoreData
      });
      if (this.parserOptions.supportsComments) {
        return this.parseWithComments(scanner);
      }
      return this.parseWithoutComments(scanner);
    }
  }, {
    key: "parseWithoutComments",
    value: function parseWithoutComments(scanner) {
      var rows = [];
      var shouldContinue = true;
      while (shouldContinue) {
        shouldContinue = this.parseRow(scanner, rows);
      }
      return {
        line: scanner.line,
        rows: rows
      };
    }
  }, {
    key: "parseWithComments",
    value: function parseWithComments(scanner) {
      var parserOptions = this.parserOptions;
      var rows = [];
      for (var nextToken = scanner.nextCharacterToken; nextToken !== null; nextToken = scanner.nextCharacterToken) {
        if (Token_1.Token.isTokenComment(nextToken, parserOptions)) {
          var cursor = scanner.advancePastLine();
          if (cursor === null) {
            return {
              line: scanner.lineFromCursor,
              rows: rows
            };
          }
          if (!scanner.hasMoreCharacters) {
            return {
              line: scanner.lineFromCursor,
              rows: rows
            };
          }
          scanner.truncateToCursor();
        } else if (!this.parseRow(scanner, rows)) {
          break;
        }
      }
      return {
        line: scanner.line,
        rows: rows
      };
    }
  }, {
    key: "parseRow",
    value: function parseRow(scanner, rows) {
      var nextToken = scanner.nextNonSpaceToken;
      if (!nextToken) {
        return false;
      }
      var row = this.rowParser.parse(scanner);
      if (row === null) {
        return false;
      }
      if (this.parserOptions.ignoreEmpty && RowParser_1.RowParser.isEmptyRow(row)) {
        return true;
      }
      rows.push(row);
      return true;
    }
  }], [{
    key: "removeBOM",
    value: function removeBOM(line) {
      // Catches EFBBBF (UTF-8 BOM) because the buffer-to-string
      // conversion translates it to FEFF (UTF-16 BOM)
      if (line && line.charCodeAt(0) === 0xfeff) {
        return line.slice(1);
      }
      return line;
    }
  }]);
}();
exports.Parser = Parser;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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